import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { AgentManagement } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreateAgent, UpdateAgent, FindAgentList } from './interfaces';

export const createAgent = createAsyncThunk(
    'agentManagement/createAgent',
    async (values: CreateAgent, { rejectWithValue }) => {
        try {
            const response = await AgentManagement.create(values);
            toast.success('Agent created successfully.');
            return response;
        } catch (error: any) {
            toastHandler(error);
            return rejectWithValue(error.message);
        }
    }
);

export const updateAgent = createAsyncThunk(
    'agentManagement/updateAgent',
    async ({ id, ...values }: UpdateAgent, { rejectWithValue }) => {
        try {
            const response = await AgentManagement.patch(id, values);
            toast.success('Agent updated successfully.');
            return response;
        } catch (error: any) {
            toastHandler(error);
            return rejectWithValue(error.message);
        }
    }
);

export const deleteAgent = createAsyncThunk(
    'agentManagement/deleteAgent',
    async (id: string, { rejectWithValue }) => {
        try {
            const response = await AgentManagement.remove(id);
            toast.success('Agent deleted successfully.');
            return response;
        } catch (error: any) {
            toastHandler(error);
            return rejectWithValue(error.message);
        }
    }
);

export const findAgents = createAsyncThunk(
    'agentManagement/findAgents',
    async (values: FindAgentList, { rejectWithValue }) => {
        try {
            const response = await AgentManagement.find({
                query: values,
            });
            return response;
        } catch (error: any) {
            toastHandler(error);
            return rejectWithValue(error.message);
        }
    }
);

